<template>
  <div>
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
    <Dialog
      :visible.sync="show"
      :style="{ width: $isMobile() ? '100vw' : '30vw', position: 'relative' }"
      :header="'Alterar Estado do Ticket'"
      :modal="true"
      :closable="false"
    >
      <form
        name="HelpdeskTicketsChangeStatus"
        class="p-col-12"
        @submit.prevent="setStatus"
        style="min-height: 15vh"
      >
        <Loading
          :active.sync="showLoader"
          :isFullPage="false"
          :zIndex="9000"
        ></Loading>
        <p v-if="!selected">
          <b>Ticket {{ ticketId }} | {{ ticketSubject }}</b>
        </p>
        <p v-else v-for="ticketSelected in selected" :key="ticketSelected.id">
          <b>Ticket {{ ticketSelected.id }} | {{ ticketSelected.subject }}</b>
        </p>
        <div class="p-fluid p-formgrid p-grid" style="min-height: 50vh">
          <div class="p-field p-col-12 p-md-12 p-mt-4">
            <span class="p-float-label">
              <Dropdown
                name="ticketStatus"
                :options="statusList"
                :filter="true"
                :optionLabel="'name'"
                :optionValue="'status'"
                v-model="current"
                v-validate="'required'"
                v-bind:class="[
                  { 'p-invalid': errors.has('ticketStatus') },
                  'form-control',
                ]"
              >
              </Dropdown>
              <label for="ticketStatus">Selecionar Estado do Ticket</label>
            </span>
            <small
              v-if="errors.has('ticketStatus')"
              class="p-error"
              role="alert"
            >
              Estado é obrigatório
            </small>
          </div>
        </div>
      </form>
      <template #footer>
        <Button
          :label="'Guardar'"
          icon="pi pi-check"
          class="p-button-success"
          @click="setStatus"
        />
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-danger"
          @click="cancel"
        />
      </template>
    </Dialog>
  </div>
</template>
<script>
import ticketService from "../../services/tickets.service";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "ChangeStatus",
  components: {
    Loading,
  },
  props: [
    "showToast",
    "show",
    "statusId",
    "ticketId",
    "ticketSubject",
    "selected",
  ],
  watch: {
    statusId() {
      this.showLoader = false;
      this.$validator.pause();
      this.$validator.reset();
      this.current = !this.selected ? this.statusId : null;
    },
  },
  data() {
    return {
      current: !this.selected ? this.statusId : null,
      statusList: [],
      showLoader: false,
    };
  },
  created() {
    this.getStatusList();
  },
  methods: {
    getStatusList() {
      return ticketService
        .getStatusList()
        .then((response) => (this.statusList = response));
    },
    cancel() {
      return this.$emit("cancel");
    },
    setStatus() {
      this.$validator.validateAll().then((isValid) => {
        if (!isValid) {
          this.loading = false;
          return;
        }
        this.$validator.pause();
        this.$validator.reset();
        if (this.selected != null) {
          return this.setStatusMultipleTickets();
        }
        this.showLoader = true;
        return ticketService
          .setStatus(this.ticketId, { status_id: parseInt(this.current) })
          .then((response) => {
            this.showLoader = false;
            if (!response) {
              if (this.showToast) {
                this.$toast.add({
                  severity: "error",
                  summary: "Erro ao alterar o estado do ticket",
                  detail: "",
                  life: 3000,
                });
              }
              return this.$emit("changedTicketStatus", {
                status: "error",
              });
            }

            if (this.showToast) {
              this.$toast.add({
                severity: "success",
                summary: `Estado do ticket alterada com sucesso`,
                detail: ``,
                life: 3000,
              });
            }
            return this.$emit("changedTicketStatus", {
              status: "ok",
              result: response,
            });
          });
      });
    },
    async setStatusMultipleTickets() {
      let noErrors = true;
      let res = null;
      this.showLoader = true;
      for (const ticket of this.selected) {
        await ticketService
          .setStatus(ticket.id, { status_id: parseInt(this.current) })
          .then((response) => {
            if (!response) {
              return (noErrors = false);
            }
            res = response;
          });
      }
      this.showLoader = false;
      if (!noErrors) {
        if (this.showToast) {
          this.$toast.add({
            severity: "error",
            summary: "Erro ao alterar o estado do ticket",
            detail: "",
            life: 3000,
          });
        }
        return this.$emit("changedTicketStatus", {
          status: "error",
        });
      }
      if (this.showToast) {
        this.$toast.add({
          severity: "success",
          summary: `Estado do ticket alterada com sucesso`,
          detail: ``,
          life: 3000,
        });
      }
      return this.$emit("changedTicketStatus", {
        status: "ok",
        result: res,
      });
    },
  },
};
</script>
